export class SplashScreen {
  static show = () => { } // Nothing to see here. Have you ever seen a splashscreen on the web?
  static hide = () => { }
}
